<template>
  <div id="industrial-distribution" :style="{width: '100%', height: '100%'}"></div>
</template>

<script>
export default {
  name: "industrialDistribution",
  props: ["data"],
  data() {
    return {
      chordData: null,
    }
  },
  watch:{
    data:{
      handler(){
        this.getOption()
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.getOption()
    })
  },
  methods: {
    getOption() {
      this.chordData = this.$echarts.init(document.getElementById('industrial-distribution'));
      let option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          bottom: 25,
        },
        grid: {
        },
        series: [
          {
            name: '产业分布数量',
            type: 'pie',
            radius: ['62%', '70%'],
            center: ['50%', '43%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.data,
          }
        ]
      };
      this.chordData.off("click");
      this.chordData.off("mouseover");
      this.chordData.on('click', function (p) {
        // _this.$router.push({path: '/searchTechnology', query: {type: -1, name: p.data.name}})
        console.log(p);
      });
      this.chordData.setOption(option);
    }

  }
}
</script>

<style scoped>

</style>
